import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6ae536ac")

_pushScopeId("data-v-6ae536ac")
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "data second alert-message" }
const _hoisted_3 = { class: "data second alert-message" }
const _hoisted_4 = { class: "input-border first" }
const _hoisted_5 = /*#__PURE__*/_createVNode("label", { for: "title" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { class: "text" }, "Název (max. 30 znaků)", -1)
const _hoisted_7 = { class: "group" }
const _hoisted_8 = { class: "border-gr short" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_ctx.message !== undefined)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("h2", null, "Jazyk: " + _toDisplayString(_ctx.message.lang.toUpperCase()), 1)
        ]),
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _hoisted_5,
            _hoisted_6,
            _createVNode("div", _hoisted_7, [
              _createVNode("div", _hoisted_8, [
                _createVNode("input", {
                  value: _ctx.message.text,
                  onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('set-message', _ctx.message, $event.target.value))),
                  type: "text",
                  autocomplete: "nope"
                }, null, 40, ["value"])
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
})